// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"248":"polyfill~intersectionObserver","312":"polyfill~fetch"}[chunkId] || chunkId) + "-" + {"114":"a4d0745d1020f4454644","248":"61cd12ceb90efb2c0780","312":"f3eac560deb1abd3d500"}[chunkId] + ".chunk.js";
};